import type { RedesignBucketFilter } from "../../utils/redesignBuckets";

const OPTIONS: { value: RedesignBucketFilter; label: string; title: string }[] = [
  { value: "all", label: "All", title: "Every case" },
  {
    value: "blunder",
    label: "Blunder",
    title:
      "Design Mistake, Note missed, Files Mistake, Client Preference Missed, Minor Design Mistake",
  },
  {
    value: "normal",
    label: "Normal",
    title: "Query, Design Preference, Need to improve design quality, Others",
  },
];

export function RedesignBucketToggle({
  value,
  onChange,
}: {
  value: RedesignBucketFilter;
  onChange: (value: RedesignBucketFilter) => void;
}) {
  return (
    <div
      className="inline-flex rounded-full border border-[#E8E8E4] bg-white p-0.5"
      role="group"
      aria-label="Redesign reason"
    >
      {OPTIONS.map((option) => {
        const active = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            title={option.title}
            onClick={() => onChange(option.value)}
            className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
              active
                ? option.value === "blunder"
                  ? "bg-red-600 text-white"
                  : "bg-[#345952] text-white"
                : "text-[#4A4A48] hover:bg-[#F4F4F2]"
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
